import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase, ActionIconListItem } from 'library/styles/icon';
import { Header4 } from 'library/styles/text';
import { TYPE } from 'store/browse-items/fixtures';

const BatchSelectContainer = styled.div`
  position: fixed;
  left: 72px;
  right: 0;
  bottom: 0;
  z-index: 20;
`;

const List = styled.ul`
  float: right;
  padding-right: 10px;
  margin: 0;
  padding-left: 6px;
  list-style: none;
  color: ${Colors.violet};
`;

const ListItem = styled(ActionIconListItem)`
`;

const Container = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 40px;
  padding-right: 26px;
  height: 72px;
  box-sizing: border-box;
  background-color: ${Colors.violet};
  ${(props) => {
    if (props.type === TYPE.SET) {
      return `background-color: ${Colors.blue}`;
    }

    if (props.type === TYPE.COLOR) {
      return `background-color: ${Colors.shade02}`;
    }

    if (props.type === TYPE.IMAGE) {
      return `background-color: ${Colors.shade05}`;
    }

    if (props.type === TYPE.PROJECT) {
      return `background-color: ${Colors.shade05}`;
    }

    return '';
  }};
`;

const Icon = styled(IconBase)`
`;

const Header = styled(Header4)`
  display: inline-block;
  margin-top: 9px;
  color: ${Colors.shade08};
  
  span {
    cursor: pointer;
  }
`;

export {
  BatchSelectContainer,
  Container,
  Header,
  List,
  ListItem,
  Icon,
};
